/** Guardrails for cloud pack bytes + Sentry reporting (zw-app). */

import * as Sentry from "@sentry/vue";

export type PackEvent = "detected" | "rejected_upload" | "heal";

/** True when bytes look like a git packfile (`PACK` + 8-byte header). */
export function isValidPackWire(bytes: Uint8Array): boolean {
  if (bytes.byteLength < 12) return false;
  return (
    bytes[0] === 0x50 &&
    bytes[1] === 0x41 &&
    bytes[2] === 0x43 &&
    bytes[3] === 0x4b
  );
}

export function packPrefixPreview(bytes: Uint8Array): string {
  const n = Math.min(bytes.byteLength, 48);
  const slice = bytes.subarray(0, n);
  let out = "";
  for (let i = 0; i < slice.length; i++) {
    const c = slice[i];
    if (typeof c !== "number") continue;
    out += c >= 32 && c < 127 ? String.fromCharCode(c) : ".";
  }
  return out;
}

export function reportCorruptPack(
  event: PackEvent,
  extra: Record<string, string | number | boolean>,
): void {
  const message =
    event === "detected"
      ? "Corrupt cloud pack detected"
      : event === "rejected_upload"
        ? "Corrupt pack rejected before upload"
        : "Healing corrupt cloud pack with full upload";

  Sentry.captureMessage(message, {
    level: "error",
    tags: { feature: "cloud-pack", pack_event: event },
    extra,
  });
}
